import clsx from 'clsx';
import React from 'react';
import { withStyles } from '@material-ui/core';

import styles from './style';
import TextField from '../atomic/TextField';
import SearchIcon from '../../assets/icons/Search';
import InputAdornment from '../atomic/InputAdornment';

const SearchField = ({
  classes,
  bordered,
  className,
  inputFieldClassName,
  placeholder,
  value,
  onChange,
  ...props
}) => {
  return (
    <TextField
      placeholder={placeholder}
      className={clsx(classes.textField, className)}
      InputProps={{
        className: clsx(classes.inputField, inputFieldClassName),
        startAdornment: (
          <InputAdornment className={classes.searchIconWrapper}>
            <SearchIcon className={classes.searchIcon} />
          </InputAdornment>
        ),
      }}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};

export default withStyles(styles)(SearchField);
